import {Component, Inject, OnDestroy, PLATFORM_ID} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';
import {resetNotifications} from '@store/actions/global.actions';
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {
    NotificationContentComponent
} from "@iw-shop/core/components/notification-content/notification-content.component";
import {faCircleExclamation} from "@fortawesome/free-solid-svg-icons";
import {map, takeUntil} from "rxjs/operators";
import {isPlatformBrowser} from "@angular/common";

@Component({
    selector: 'core-notifications-handler',
    standalone: false,
    templateUrl: './notifications-handler.component.html',
    styleUrls: ['./notifications-handler.component.scss'],
    providers: [DialogService]
})
export class NotificationsHandlerComponent implements OnDestroy {
    private readonly isBrowser: boolean

    destroy$: Subject<boolean> = new Subject<boolean>();
    notifications$: Observable<{
        id: string,
        notification: string,
        type: 'info' | 'error'
    }[] | null>;

    displayedNotificationIds: string[] = [];

    refError:  DynamicDialogRef<any> | null | undefined;
    refInfo:  DynamicDialogRef<any> | null | undefined;

    constructor(private store: Store<AppState>, public dialogService: DialogService, @Inject(PLATFORM_ID) platformId: Object,) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.notifications$ = this.store.select(state => state.global.notifications);
        this.notifications$
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe(
                r => {
                    if(!this.isBrowser){
                        r?.map(x => {
                            console.log(x.type, x.notification);
                        })
                        return;
                    }
                    if (!r?.filter(x => x.type == 'error')[0] &&
                        this.refError) {
                        this.refError.close();
                    }
                    if (!r?.filter(x => x.type == 'info')[0] &&
                        this.refInfo) {
                        this.refInfo.close();
                    }
                    r?.map(
                        n => {

                            if(!this.displayedNotificationIds.includes(n.id)){
                                this.show(n.type);
                            }
                            this.displayedNotificationIds.push(n.id);
                        }
                    )

                }
            )
    }

    ngOnInit(): void {
    }

    isError(){

    }

    show(type: 'error' | 'info') {
        switch (type) {
            case 'error':
                if(this.refError){
                    return;
                }
                this.refError = this.dialogService.open(NotificationContentComponent, {
                    data: {
                        types: ['error']
                    },
                    header: 'Ups, das hätte nicht passieren dürfen!',
                    width: '70%',
                    contentStyle: {overflow: 'auto'},
                    baseZIndex: 10000,
                    maximizable: false
                });
                this.refError?.onClose.subscribe(() => {
                    this.refError = undefined;
                });
                break;

            case 'info':
                if(this.refInfo){
                    return;
                }
                this.refInfo = this.dialogService.open(NotificationContentComponent, {
                    data: {
                        types: ['info']
                    },
                    header: '',
                    style: {
                        'max-width': '70%',
                    },
                    contentStyle: {overflow: 'auto'},
                    baseZIndex: 10000,
                    maximizable: false,

                    dismissableMask: true
                });
                this.refInfo?.onClose.subscribe(() => {
                    this.store.dispatch(resetNotifications({types: ['info']}));
                    this.refInfo = undefined;
                });
                setTimeout(() => {
                    const closeListener = () => {
                        this.refInfo?.close();
                        document.removeEventListener('click', closeListener);
                    };
                    document.addEventListener('click', closeListener);
                }, 100);
                break;

        }

    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    protected readonly faCircleExclamation = faCircleExclamation;
}
